import { TVideoType } from '../../../../common/videoUtils';
import { EventMode } from '../../../../types/eventTypes';
import { ILiveEventVideoConfig } from './types';

export const SHOW_DUNGEONS_IN_LEADERBOARD_RUNS_BRACKET_CARD_CONTENT = false;

export interface ILiveEventSectionThemeConfig {
  videoUrl: string | null;
  imageUrl: string | null;
}

/**
 * Note: use with asset()
 * Example: asset('./path/to/image.jpg')
 */
export const LIVE_EVENT_SECTION_THEME_CONFIG: Partial<Record<EventMode, ILiveEventSectionThemeConfig>> = Object.freeze({
  [EventMode.WAITING_REGISTRATION]: {
    videoUrl: null,
    imageUrl: null
  },
  [EventMode.ACTIVE]: {
    videoUrl: null,
    imageUrl: null
  },
  [EventMode.WAITING_EVENT_START]: {
    videoUrl: null,
    imageUrl: null
  },
  [EventMode.STARTED]: {
    videoUrl: null,
    imageUrl: null
  }
});

/**
 * Started Live Event Video Config
 */
export const DEFAULT_LIVE_MASTHEAD_VIDEO_CONFIG = Object.freeze<ILiveEventVideoConfig>({
  videoId: 'i98f-5KQ0QI',
  videoType: TVideoType.Youtube,
  autoplay: false,
  thumbnail: false
});
